import { normalizeCodeForDisplay } from './codeDisplay';
import { diffLines, summarizeDiff, type DiffRow, type DiffStats } from './lineDiff';

/**
 * How far apart two versions of a program are — the one way it is measured.
 *
 * "How many lines changed" used to be worked out in three places by three
 * methods: the diff view (line LCS over the displayed code), the version note
 * (an order-blind bag of lines) and the closing summary (the rounds' edit sizes
 * added up). One delivery read 「V1.0 → V1.4 +85 −46」 in the diff header and
 * 「程序改动 +77 / −65 行」 two lines below it (inspection I-041). Every number
 * shown for a pair of versions now comes from the rows the diff view draws.
 */
export function diffDisplayedCode(before: string, after: string): DiffRow[] {
  return diffLines(normalizeCodeForDisplay(before), normalizeCodeForDisplay(after));
}

export function measureCodeChange(before: string, after: string): DiffStats {
  return summarizeDiff(diffDisplayedCode(before, after));
}
